import { VITE_ENV } from 'config';

/**
 * Configuration for work task cache management and eviction.
 * Uses StorageMetadataService for device-aware eviction based on actual storage quotas.
 */
export const WORK_TASK_CACHE_CONFIG = {
  // Storage thresholds (percentage of device quota)
  maxStorageUtilizationPercent: parseFloat(VITE_ENV.workTasks.maxStorageUtilization),
  criticalStorageUtilizationPercent: parseFloat(VITE_ENV.workTasks.criticalStorageUtilization),

  // Minimum free space to maintain (bytes)
  minAvailableBytes: parseInt(VITE_ENV.workTasks.minAvailableBytes),

  // Fallback count limit (when Storage API not available)
  maxTasks: parseInt(VITE_ENV.workTasks.maxCachedTasks),

  // Eviction batch sizes
  evictionBatchSize: parseInt(VITE_ENV.workTasks.evictionBatchSize),
  criticalEvictionBatchSize: parseInt(VITE_ENV.workTasks.criticalEvictionBatchSize),

  // TanStack Query cache configuration
  gcTime: 1 * 60 * 60 * 1000, // 1 hour
};
